import { ArrowLeft, Calendar, FileText, Globe, Layers } from 'lucide-react';

function DocumentBackButton({ onBack }) {
  return (
    <button
      type="button"
      data-testid="document-view-back-button"
      onClick={onBack}
      className="mb-4 flex items-center gap-2 text-muted-foreground transition-colors hover:text-white"
    >
      <ArrowLeft className="h-4 w-4" />
      <span className="text-sm">Retour</span>
    </button>
  );
}

function DocumentSourceIcon({ sourceType }) {
  return sourceType === 'pdf'
    ? <FileText className="h-6 w-6 text-blue-400" />
    : <Globe className="h-6 w-6 text-green-400" />;
}

function DocumentMetaRow({ document }) {
  return (
    <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
      <span className="flex items-center gap-1">
        <span className="rounded bg-zinc-800 px-2 py-0.5 font-mono text-xs uppercase">{document.source_type}</span>
      </span>
      <span className="flex items-center gap-1">
        <Layers className="h-4 w-4" />
        <span>{document.chunk_count} chunk{document.chunk_count > 1 ? 's' : ''}</span>
      </span>
      {document.created_at ? (
        <span className="flex items-center gap-1">
          <Calendar className="h-4 w-4" />
          <span>{new Date(document.created_at).toLocaleDateString('fr-FR')}</span>
        </span>
      ) : null}
    </div>
  );
}

function DocumentSourceLink({ sourceUrl }) {
  if (!sourceUrl) {
    return null;
  }

  return (
    <a
      data-testid="document-view-source-link"
      href={sourceUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="mt-2 block truncate text-sm text-blue-400 hover:text-blue-300"
    >
      {sourceUrl}
    </a>
  );
}

function DocumentHeaderContent({ document }) {
  return (
    <div className="min-w-0 flex-1">
      <h1 data-testid="document-view-title" className="mb-2 text-2xl font-serif tracking-tight">{document.title}</h1>
      <DocumentMetaRow document={document} />
      <DocumentSourceLink sourceUrl={document.source_url} />
    </div>
  );
}

export const DocumentViewHeader = ({ document, onBack }) => (
  <div className="sticky top-0 z-10 border-b border-border bg-background/95 backdrop-blur-sm">
    <div className="mx-auto max-w-4xl p-6">
      <DocumentBackButton onBack={onBack} />
      <div className="flex items-start gap-4">
        <div className="rounded-sm border border-zinc-800 bg-zinc-900 p-3">
          <DocumentSourceIcon sourceType={document.source_type} />
        </div>
        <DocumentHeaderContent document={document} />
      </div>
    </div>
  </div>
);
